import { useReducer } from 'react';

const prefix = `idk123::`;
const MARK_AS_REVIEWED_REQUEST = `${prefix}MARK_AS_REVIEWED_REQUEST`;
const MARK_AS_REVIEWED_SUCCESS = `${prefix}MARK_AS_REVIEWED_SUCCESS`;
const MARK_AS_REVIEWED_FAILURE = `${prefix}MARK_AS_REVIEWED_FAILURE`;
const HYDRATE = `${prefix}HYDRATE`;

const ACTION_TYPES = {
  MARK_AS_REVIEWED_REQUEST,
  MARK_AS_REVIEWED_SUCCESS,
  MARK_AS_REVIEWED_FAILURE,
  HYDRATE
};

const markAsReviewedRequest = () => ({
  type: ACTION_TYPES.MARK_AS_REVIEWED_REQUEST
});

const markAsReviewedSuccess = holdData => ({
  type: ACTION_TYPES.MARK_AS_REVIEWED_SUCCESS,
  payload: {
    holdData
  }
});

const markAsReviewedFailure = error => ({
  type: ACTION_TYPES.MARK_AS_REVIEWED_FAILURE,
  error
});

const hydrate = data => ({
  type: ACTION_TYPES.HYDRATE,
  payload: {
    data
  }
});

const ACTIONS = {
  markAsReviewedRequest,
  markAsReviewedSuccess,
  markAsReviewedFailure,
  hydrate
};

const initialState = {
  isLoading: false,
  statusMessage: '',
  holdData: []
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.HYDRATE: {
      const { payload } = action;

      return {
        ...state,
        holdData: [...payload.data]
      };
    }

    case ACTION_TYPES.MARK_AS_REVIEWED_REQUEST: {
      return {
        ...state,
        statusMessage: 'Marking hold as reviewed',
        isLoading: true
      };
    }

    case ACTION_TYPES.MARK_AS_REVIEWED_SUCCESS: {
      const { payload } = action;

      return {
        ...state,
        isLoading: false,
        statusMessage: '',
        holdData: [...payload.holdData]
      };
    }

    case ACTION_TYPES.MARK_AS_REVIEWED_FAILURE: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    default: {
      throw Error('useHoldSection hook default reducer case should never hit');
    }
  }
};

const useHoldSection = service => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const markAsReviewed = (encounterId, comment) => {
    dispatch(ACTIONS.markAsReviewedRequest());

    return service.markAsReviewed(encounterId, comment)
      .then(result => {
        dispatch(ACTIONS.markAsReviewedSuccess(result));
      })
      .catch(e => dispatch(ACTIONS.markAsReviewedFailure(e.toString())));
  };

  const hydrate = data => dispatch(ACTIONS.hydrate(data));

  const boundActions = {
    markAsReviewed,
    hydrate
  };

  return [
    {
      ...state
    },
    boundActions
  ];
};

export default useHoldSection;
